export enum AuctionOperationPageStatus {
  /**
   * 待发布
   */
  WAIT_PUBLISH = 0,

  /**
   * 待审核
   */
  WAIT_AUDIT = 1,

  /**
   * 审核不通过
   */
  AUDIT_FAIL = 2,

  /**
   * 待开始
   */
  WAIT_START = 3,

  /**
   * 竞价中
   */
  BIDDING = 4,

  /**
   * 已结束
   */
  END = 5,

  /**
   * 委托方已确认
   */
  ENTRUST_CONFIRMED = 6,

  /**
   * 已成交
   */
  DEAL = 7,

  /**
   * 部分成交
   */
  DEAL_PART = 8,

  /**
   * 流拍
   */
  DEAL_FAIL = 9,

  /**
   * 委托方终止交易
   */
  ENTRUST_HALT = 10,

  /**
   * 终止未通过
   */
  HALT_FAIL = 11,

  /**
   * 已终止
   */
  HALT_SUCCESS = 12
}

export const AuctionOperationPageStatusTextMap = {
  [AuctionOperationPageStatus.WAIT_PUBLISH]: '待发布',
  [AuctionOperationPageStatus.WAIT_AUDIT]: '待审核',
  [AuctionOperationPageStatus.AUDIT_FAIL]: '审核不通过',
  [AuctionOperationPageStatus.WAIT_START]: '待开始',
  [AuctionOperationPageStatus.BIDDING]: '竞价中',
  [AuctionOperationPageStatus.END]: '已结束',
  [AuctionOperationPageStatus.ENTRUST_CONFIRMED]: '委托方已确认',
  [AuctionOperationPageStatus.DEAL]: '已成交',
  [AuctionOperationPageStatus.DEAL_PART]: '部分成交',
  [AuctionOperationPageStatus.DEAL_FAIL]: '流拍',
  [AuctionOperationPageStatus.ENTRUST_HALT]: '委托方申请终止',
  [AuctionOperationPageStatus.HALT_FAIL]: '终止未通过',
  [AuctionOperationPageStatus.HALT_SUCCESS]: '已终止'
}

export const AuctionOperationPageStatusColorMap = {
  [AuctionOperationPageStatus.WAIT_PUBLISH]: 'default',
  [AuctionOperationPageStatus.WAIT_AUDIT]: 'default',
  [AuctionOperationPageStatus.AUDIT_FAIL]: 'default',
  [AuctionOperationPageStatus.WAIT_START]: 'default',
  [AuctionOperationPageStatus.BIDDING]: 'processing',
  [AuctionOperationPageStatus.END]: 'default',
  [AuctionOperationPageStatus.ENTRUST_CONFIRMED]: 'success',
  [AuctionOperationPageStatus.DEAL]: 'success',
  [AuctionOperationPageStatus.DEAL_PART]: 'success',
  [AuctionOperationPageStatus.DEAL_FAIL]: 'default',
  [AuctionOperationPageStatus.ENTRUST_HALT]: 'warning',
  [AuctionOperationPageStatus.HALT_FAIL]: 'default',
  [AuctionOperationPageStatus.HALT_SUCCESS]: 'default'
}
